import "!../../node_modules/mini-css-extract-plugin/dist/loader.js?{}!css-loader?{\"modules\":false,\"url\":false}!./spinner.treat.3pHKHrF.css";
export var spinnerStyles = {container:'_14NqD',g:'_1JmQi',cover:'_3ZCH0'};